import React from 'react';


class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error("Uncaught error:", error, errorInfo);
    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      // Fallback UI
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-[#0a1220] p-4 text-center">
          <div className="max-w-md w-full bg-white dark:bg-[#162032] shadow-xl rounded-2xl p-8 border border-gray-200 dark:border-gray-800">
            <h1 className="text-4xl mb-4">😵ops!</h1>
            <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">Something went wrong</h2>
            <p className="text-gray-500 dark:text-gray-400 mb-6">
              We encountered an unexpected error. Our team has been notified.
            </p>

            <div className="bg-red-50 dark:bg-red-900/20 p-4 rounded-lg mb-6 text-left overflow-auto max-h-40">
              <code className="text-xs text-red-600 dark:text-red-400 font-mono break-all">
                {this.state.error && this.state.error.toString()}
              </code>
            </div>

            <div className="flex flex-col gap-3">
              <button
                onClick={() => window.location.reload()}
                className="w-full py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-colors"
              >
                Reload Page
              </button>
              <a href="/" className="text-sm text-gray-500 hover:text-gray-700 dark:hover:text-gray-300">
                Return to Home
              </a>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
